export default "__VITE_ASSET__Cmej_vAv__"